module.exports = __webpack_public_path__ + "assets/img/in-page-banner.87d97f76.svg";